export enum ProgramAvailablity {
    Available,
    Locked,
    Missing,
    Finished,
    Forbiden,
    CominSoon,
    CountDown,
    NotFound,
    Simultaneous,
    Unauthorized,
    NeedPackage,
    ChangeStream,
    CapacityExceed,
    QualityNeedPackageCountdown,
    NeedPackageCountDown,
    ForbidenNoButton,
    DeviceAccessTerminated,
    MustRedirect
}